export const endpoint = process.env.REACT_APP_API_URL;
export const pdbciffileurl = process.env.REACT_APP_PDB_CIF_FILE_URL;